import React from 'react';
import classNames from 'classnames';

import CircularProgress from 'components/partials/circular-progress/circular-progress';

interface LessonsSidebarItemClickArgs {
  event: React.MouseEvent<HTMLAnchorElement>;
  to: string;
  id: string | number;
}

interface LessonsSidebarItemProps {
  index: number;
  id: string | number;
  name?: string;
  onClick: (args: LessonsSidebarItemClickArgs) => void;
  courseId: string | number;
  currentLessonId: string | number;
  progress?: number;
}

const LessonsSidebarItem = React.memo(
  ({
    index,
    id,
    name,
    onClick,
    courseId,
    currentLessonId,
    progress,
  }: LessonsSidebarItemProps): React.JSX.Element => {
    const isActive = currentLessonId == id; //Might be number and string

    const lessonLink = `/learn/courses/${courseId}/lesson/${id}`;

    return (
      <li
        className={classNames('p-2 transition rounded-md', {
          'bg-navy-50': isActive,
        })}
      >
        <a
          href={lessonLink}
          onClick={(e) => onClick({ event: e, to: lessonLink, id })}
          className={classNames(
            'block text-sm bg-transparent hover:text-navy-800 font-semibold text-gray-600 flex items-center justify-between no-underline',
            {
              'text-navy-800 hover:text-navy-800': isActive,
            }
          )}
        >
          <div className="max-w-[200px] break-words">
            <span>{`${index + 1}. `}</span>
            {name}
          </div>

          <CircularProgress progress={progress} />
        </a>
      </li>
    );
  }
);

export default LessonsSidebarItem;
